export default "__VITE_ASSET__059830ed__"